import { default as React, FunctionComponent, useState } from 'react'
import BasePopover from '../../components/BasePopover'
import { Link, useParams } from 'react-router-dom'
import Gear from '../../icons/gear.svg'
import ClickOutside from '../../components/ClickOutside'
import ImportDialog from '../../components/ImportDialog'
import { uploadShipments, uploadUsers } from '../../accounts/accountsActions'
import AsyncImportDialog from '../../components/AsyncImportDialog'

const ClientSettings: FunctionComponent = () => {
  const { accountId: accountIdParam } = useParams()
  const accountId = Number(accountIdParam)
  const [open, setOpen] = useState(false)
  const [importUsersOpen, setImportUsersOpen] = useState(false)
  const [importShipmentsOpen, setImportShipmentsOpen] = useState(false)

  return (
    <>
      <ClickOutside onClickOutside={() => setOpen(false)}>
        <BasePopover
          className="menu_popup -settings"
          isOpen={open}
          offset={20}
          body={
            <>
              <Link
                className="menu_popup-link"
                to={`/clients/${accountId}/settings`}
              >
                Account Settings
              </Link>
              <Link
                className="menu_popup-link"
                to={`/clients/${accountId}/users`}
              >
                Client Users
              </Link>
              <div className="menu_popup-divider" />
              <span
                className="menu_popup-link"
                onClick={() => setImportShipmentsOpen(true)}
              >
                Import Purchases History
              </span>
              <span
                className="menu_popup-link"
                onClick={() => setImportUsersOpen(true)}
              >
                Import Users
              </span>
            </>
          }
        >
          <button
            onClick={() => setOpen(!open)}
            type="button"
            className="clear-button link menu_toggle"
          >
            <Gear />
          </button>
        </BasePopover>
      </ClickOutside>
      {importUsersOpen && (
        <ImportDialog
          close={() => setImportUsersOpen(false)}
          action={(file: File) => uploadUsers(file, accountId)}
          templateName="import_users_template.csv"
          templateUrl="/import_users_template.csv"
          title="Import Users"
        />
      )}
      {importShipmentsOpen && (
        <AsyncImportDialog
          close={() => setImportShipmentsOpen(false)}
          action={(file: File) => uploadShipments(file, accountId)}
          templateName="import_shipments_template.csv"
          templateUrl="/import_shipments_template.csv"
          title="Import Purchases History"
        />
      )}
    </>
  )
}

export default ClientSettings
